export class RepliesService2 {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    getCategoryReplies(categoryId) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/replies/${categoryId}`,
        });
    }
    delete(categoryId) {
        return this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/replies/${categoryId}`,
        });
    }
    save(customReplies, categoryId) {
        this.MessagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.collection+json',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/replies/${categoryId}`,
            resource: {
                itemType: 'application/vnd.iris.desk.custom-reply+json',
                items: customReplies,
            },
        });
    }
    getAllCategories(skip, take) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/replies?$skip=${skip}&$take=${take}`,
        });
    }
}
RepliesService2.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
